import script from "./PastNotesList.vue?vue&type=script&setup=true&lang=js"
export * from "./PastNotesList.vue?vue&type=script&setup=true&lang=js"

import "./PastNotesList.vue?vue&type=style&index=0&id=5b44a510&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b44a510"]])

export default __exports__